// extracted by mini-css-extract-plugin
export default {"filterContainer":"LayerSummary_filterContainer__Nq8j4","filtersLabel":"LayerSummary_filtersLabel__6GE7m","layer":"LayerSummary_layer__Ju6CT","label":"LayerSummary_label__dXerq"};